<template>
  <div>
    <div class="form-container">
      <ProgressBar :progressPercent="20" progressLabel="Step 1 of 5" />
      <h1 class="step-title">Personal Data</h1>
      <div class="row">
        <div class="col-md-4">
          <input
            type="text"
            class="form-control shadow-none"
            @input="updateField('nameFirst', $event.target.value)"
            :value="one.nameFirst"
            placeholder="First Name"
          />
          <div class="e-wrapper">
            <p v-if="!$v.one.nameFirst.required" class="small required">
              * First Name Required
            </p>
          </div>
        </div>

        <div class="col-md-4">
          <input
            type="text"
            class="form-control shadow-none"
            @input="updateField('nameMiddle', $event.target.value)"
            :value="one.nameMiddle"
            placeholder="Middle Initial"
          />
        </div>
        <div class="col-md-4">
          <input
            type="text"
            class="form-control shadow-none"
            @input="updateField('nameLast', $event.target.value)"
            :value="one.nameLast"
            placeholder="Last Name"
          />
          <div class="e-wrapper">
            <p v-if="!$v.one.nameLast.required" class="small required">
              * Last Name Required
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          <input
            type="text"
            class="form-control shadow-none"
            @input="updateAddress('street', $event.target.value)"
            :value="one.address.street"
            placeholder="Street"
          />
          <div class="e-wrapper"></div>
          <p class="small">
            Please enter your residence address <strong>outside</strong> of
            Mexico.
          </p>
        </div>
        <div class="col-md-3">
          <input
            type="text"
            class="form-control shadow-none"
            @input="updateAddress('city', $event.target.value)"
            :value="one.address.city"
            placeholder="City"
          />
        </div>
        <div class="col-md-3">
          <input
            type="text"
            class="form-control shadow-none"
            @input="updateAddress('state', $event.target.value)"
            :value="one.address.state"
            placeholder="State"
          />
        </div>
        <div class="col-md-3">
          <input
            type="text"
            class="form-control shadow-none"
            @input="updateAddress('zip', $event.target.value)"
            :value="one.address.zip"
            v-mask="'##### - ####'"
            placeholder="Zip / Postal Code"
          />
          <div class="e-wrapper"></div>
          <p class="small">First 5 digits required.</p>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <input
            type="text"
            class="form-control shadow-none"
            @input="updateField('email', $event.target.value)"
            :value="one.email"
            placeholder="Email"
          />
          <div class="e-wrapper">
            <p v-if="!$v.one.email.required" class="small required">
              * Email Address Required
            </p>
          </div>
          <p class="small">
            We will <strong>NOT</strong> spam or solicit your e-mail, this is
            simply for you to receive a quotation
          </p>
        </div>
        <div class="col-md-6">
          <input
            type="text"
            class="form-control shadow-none"
            @input="updateField('phone', $event.target.value)"
            :value="one.phone"
            v-mask="' +1 (###) ###-####'"
            placeholder="Phone"
          />
          <div class="e-wrapper"></div>
          <p class="small">Please provide your U.S. or Canadian phone number</p>
        </div>
      </div>
    </div>
    <div class="step-buttons">
      <div class="spacer">
        <!-- spacer -->
      </div>
      <button class="btn btn-primary" type="button" @click="next()">
        Next
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { required } from "vuelidate/lib/validators";
import ProgressBar from "./ProgressBar";

export default {
  components: { ProgressBar },
  computed: {
    ...mapState(["one"]),
  },
  validations: {
    one: {
      nameFirst: {
        required,
      },
      nameLast: {
        required,
      },
      email: {
        required,
      },
    },
  },
  methods: {
    ...mapActions(["updateFormOne", "nextStep"]),
    updateField(key, val) {
      const updates = { [key]: val };
      this.updateFormOne(updates);
    },
    updateAddress(key, val) {
      const updatedAddress = { ...this.one.address, [key]: val };
      this.updateFormOne({ address: updatedAddress });
    },
    next() {
      window.scrollTo(0, 0);
      if (this.$v.$invalid) {
        return;
      }
      this.nextStep();
    },
  },
};
</script>

<style></style>
